import numeral from 'numeral'

numeral.register('locale', 'it', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  currency: {
    symbol: '€'
  }
})

numeral.locale('it')

class FormatterService {
  formatCurrency(value, short) {
    return short ? numeral(parseFloat(value)).format('$ 0.0a') : numeral(parseFloat(value)).format('$ 0,0.00')
  }

  formatNumber(value) {
    return numeral(parseFloat(value)).format('0.0a')
  }

  customFormat(value, format) {
    return numeral(parseFloat(value)).format(format)
  }
}

export default new FormatterService()



// WEBPACK FOOTER //
// ./src/services/Formatter.js